export const PRODUCT_NAME = 'transfers'
export const TRANSFER = 'transfer'
